import { PropsWithChildren } from "react";
import styled from "styled-components";

import ReactPortal from "../ReactPortal/ReactPortal";

const ModalBackdrop = styled.div`
  position: fixed;
  top: 0;
  z-index: 100;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  background-color: rgba(0, 0, 0, 0.4);
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Modal = ({ children }: PropsWithChildren<unknown>) => (
  <ReactPortal wrapperId="modal-root">
    <ModalBackdrop data-testid="modal-root">{children}</ModalBackdrop>
  </ReactPortal>
);

export default Modal;
